// namespace
window.Components = window.Components || {};

(function($) {

  'use strict';

  function youtubeApi() {

    var self      = this,
        playerId  = false,
        vidId     = false,
        isInit    = false,
        playerObj = false,
        $cache    = {};

    self.isReady = false;
    self.stateChangeCallbacks = {
                                  notStarted : false,
                                  end : false,
                                  play : false,
                                  pause : false,
                                  buffer : false,
                                  queue : false
                                };

    /**
     * On Player Ready
     */
    function onPlayerReady() {
      self.isReady = true;
      $cache.main.trigger('ready');
      //console.log('player is ready');
    }

    /**
     * On Player Error
     */
    function onPlayerError(e) {
      console.log('Player Youtube Error : '+e.data);
    }

    /**
     * On Player State Change
     */
    function onPlayerStateChange(e) {
      switch (e.data) {
        case -1:
          //Video not started
          //console.log('Video not started');
          if(self.stateChangeCallbacks.notStarted && typeof self.stateChangeCallbacks.notStarted === 'function') self.stateChangeCallbacks.notStarted();
          break;
        case 0:
          //Video End
          //console.log('Video End');
          $cache.main.trigger('ended');
          if(self.stateChangeCallbacks.end && typeof self.stateChangeCallbacks.end === 'function') self.stateChangeCallbacks.end();
          break;
        case 1:
          //Video play
          //console.log('Video play');
          if(self.stateChangeCallbacks.play && typeof self.stateChangeCallbacks.play === 'function') self.stateChangeCallbacks.play();
          break;
        case 2:
          //Video pause
          //console.log('Video pause');
          if(self.stateChangeCallbacks.pause && typeof self.stateChangeCallbacks.pause === 'function') self.stateChangeCallbacks.pause();
          break;
        case 3:
          //Video buffer
          //console.log('Video buffer');
          if(self.stateChangeCallbacks.buffer && typeof self.stateChangeCallbacks.buffer === 'function') self.stateChangeCallbacks.buffer();
          break;
        case 5:
          //Video in queue
          //console.log('Video in queue');
          if(self.stateChangeCallbacks.queue && typeof self.stateChangeCallbacks.queue === 'function') self.stateChangeCallbacks.queue();
      }
    }

    /**
     * Play Video
     */
    self.playVideo = function (callback) {
      if(!playerObj) return;

      playerObj.playVideo();

      if(typeof callback === 'function') callback();
    }

    /**
     * Pause Video
     */
    self.pauseVideo = function (callback) {
      if(!playerObj) return;
      
      playerObj.pauseVideo();

      if(typeof callback === 'function') callback();
    }

    /**
     * Stop Video
     */
    self.stopVideo = function (callback) {
      if(!playerObj) return;
      
      playerObj.stopVideo();

      if(typeof callback === 'function') callback();
    }

    /**
     * Seek Video Time
     */
    self.seekVideo = function (seconds, callback) {
      if(!playerObj) return;
      
      playerObj.seekTo(seconds);

      if(typeof callback === 'function') callback();
    }

    /**
     * Load new Video
     */
    self.loadNew = function(id, callback) {
      if(!playerObj) return;
      
      playerObj.loadVideoById(id);

      if(typeof callback === 'function') callback();
    }

    /**
     * Init Youtube API
     */
    function initApi() {
      if(window.youtubeApiReady !== undefined) return;
      window.youtubeApiReady = false;

      // Insert Api
      var tag = document.createElement('script');
      tag.src = "https://www.youtube.com/iframe_api";
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      //Callback function
      window["onYouTubeIframeAPIReady"] = function(){
        //console.log('YT Api Ready');
        window.youtubeApiReady = true;

        //Trigger init for all component after Api callback
        var $components = $('[data-component="youtubeApi"]');
        $components.each(function(index){
          var $el = $(this);
          var compObj = $el.data('comp');

          if(typeof compObj.initPlayer === 'function') compObj.initPlayer();
        });
      };
    }

    /**
     * Init Player
     */
    self.initPlayer = function() {
      if(isInit) return;
      isInit = true;

      playerObj = new YT.Player(playerId, {
        videoId: vidId,
        playerVars: {rel: 0, showinfo: 0},
        events: {
          'onReady': onPlayerReady,
          'onStateChange': onPlayerStateChange,
          'onError': onPlayerError
        }
      });
    }

    /**
     * Init function
     */
    function init() {
      //Init Youtube API
      initApi();

      //Init variables
      playerId = $cache.iframe.attr('id');
      vidId = $cache.main.data('id');

      //If API is ready
      if(window.youtubeApiReady !== undefined && window.youtubeApiReady == true) {
        self.initPlayer();
      }
    }
    
    /**
     * Init Cache
     */
    function initCache(target) {
      $cache.main = target;
      $cache.iframe = $cache.main.find('.iframe-placeholder');
    }

    /**
     * Public constructor
     * @param  {Object} opts Options
     */
    self.initialize = function(target) {      
      initCache(target);

      //Initial call
      init();
    };

    self.initialize.apply(self, arguments);
    return self;
  }
  
  window.Components.youtubeApi = youtubeApi;
  
}(jQuery));
